export default function StrategyCanvasCalculator() {
  return <div>StrategyCanvasCalculator</div>;
}
